/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_LeadInputs */

const cs_gdpr_type_lead = /** @type {(inputs: Gdpr_Type_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka`)
};

const en_gdpr_type_lead = /** @type {(inputs: Gdpr_Type_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

/**
* | output |
* | --- |
* | "Lead" |
*
* @param {Gdpr_Type_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_lead = /** @type {((inputs?: Gdpr_Type_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_lead(inputs)
	return cs_gdpr_type_lead(inputs)
});